/**
 * iter76c — Invoices parent tab with two sub-tabs:
 *   • Invoices  → the existing InvoicesTab (create, send, PDF, refund flows)
 *   • Settings  → the existing InvoiceSettingsTab (branding, defaults)
 *
 * Consolidating these under one parent removes a top-level nav row
 * without changing any underlying invoice behaviour.
 */
import { useState } from "react";
import { FileText, Settings } from "lucide-react";
import InvoicesTab from "./InvoicesTab";
import InvoiceSettingsTab from "./InvoiceSettingsTab";

const SUBS = [
  { k: "invoices", l: "Invoices", Icon: FileText },
  { k: "settings", l: "Settings", Icon: Settings },
];

export default function InvoicesParentTab({ pw }) {
  const [sub, setSub] = useState("invoices");
  return (
    <div data-testid="invoices-parent-tab">
      <div className="flex gap-1.5 flex-wrap mb-5 border-b border-[#222] pb-2">
        {SUBS.map(({ k, l, Icon }) => (
          <button
            key={k}
            onClick={() => setSub(k)}
            data-testid={`invoices-sub-${k}`}
            className={`px-3 py-1.5 border font-mono text-[10px] tracking-widest uppercase inline-flex items-center gap-1.5 ${
              sub === k
                ? "bg-[var(--tc-red)] border-[var(--tc-red)] text-white"
                : "border-[#222] text-zinc-400 hover:text-white"
            }`}
          >
            <Icon size={11} /> {l}
          </button>
        ))}
      </div>
      {sub === "invoices" && <InvoicesTab pw={pw} />}
      {sub === "settings" && <InvoiceSettingsTab pw={pw} />}
    </div>
  );
}
